import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0f267a45&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=0f267a45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f267a45",
  null
  
)

export default component.exports